<div class="modal">
  <div class="modal-overlay" (click)="cancel($event)"></div>

  <div class="modal-dialog" role="document">
    <div class=" modal-content">

      <div class="modal-header">
        <span class="modal-title">{{ modalTitle }}</span>
        <span class="me-auto"></span>
        <i class="btn btn-danger bi bi-x-lg" (click)="cancel($event)"></i>
      </div>

      <div class="modal-body">
        <form id="userPasswordSetDialogForm" class="m-3">

          <div class="input-group">
            <div class="form-floating flex-grow-1">
              <input class="form-control" [type]="passwordOldShow ? 'text':'password'" name="passwordOldInputField"
                required id="passwordOldInputField" [(ngModel)]="passwordOld" #passwordOldInput="ngModel"
                autocomplete="off" placeholder=" " (input)="passwordOldInputFieldChanged()">
              <label for="passwordOldInputField" i18n="@@UserPasswordSetPasswordOldInputLabel">Old password</label>
            </div>
            <span class="input-group-text input-group-img">
              <div class="c-pointer">
                <i class="ms-1 bi" [ngClass]="passwordOldShow == true ? 'bi-eye' : 'bi-eye-slash'"
                  (click)="passwordOldShowClick()"></i>

              </div>
            </span>
          </div>

          <div class="input-group mt-2">
            <div class="form-floating flex-grow-1">
              <input class="form-control" [type]="passwordNew1Show ? 'text':'password'" name="passwordNew1InputField"
                required id="passwordNew1InputField" [(ngModel)]="passwordNew1" #passwordNew1Input="ngModel"
                autocomplete="off" placeholder=" " (input)="passwordNew1InputFieldChanged()"
                [ngClass]="{ 'is-invalid': !passwordNewMatching }" [ngClass]="{ 'ng-valid': passwordNewMatching }">
              <label for="passwordNew1InputField" i18n="@@UserPasswordSetPasswordNew1InputLabel">New
                password</label>
            </div>
            <span class="input-group-text input-group-img">
              <div class="c-pointer">
                <i class="ms-1 bi" [ngClass]="passwordNew1Show == true ? 'bi-eye' : 'bi-eye-slash'"
                  (click)="passwordNew1ShowClick()"></i>
              </div>
            </span>
          </div>

          <div class="input-group mt-2">
            <div class="form-floating flex-grow-1">
              <input class="form-control" [type]="passwordNew2Show ? 'text':'password'" name="passwordNew2InputField"
                required id="passwordNew2InputField" [(ngModel)]="passwordNew2" #passwordNew2Input="ngModel"
                autocomplete="off" placeholder=" " (input)="passwordNew2InputFieldChanged()"
                [ngClass]="{ 'is-invalid': !passwordNewMatching }" [ngClass]="{ 'ng-valid': passwordNewMatching }">
              <label for="passwordNew2InputField" i18n="@@UserPasswordSetPasswordNew2InputLabel">Confirm password</label>
            </div>
            <span class="input-group-text input-group-img">
              <div class="c-pointer">
                <i class="ms-1 bi" [ngClass]="passwordNew2Show == true ? 'bi-eye' : 'bi-eye-slash'"
                  (click)="passwordNew2ShowClick()"></i>
              </div>
            </span>
          </div>

          <div class="invalid-feedback text-wrap mt-2 ms-2 fw-bold"
            [style.display]="passwordOldIsValid ? 'none' : 'block'" i18n="@@UserPasswordSetPasswordOldInvalidWarning">
            Your old password must be provided</div>

          <div class="invalid-feedback text-wrap mt-2 ms-2 fw-bold"
            [style.display]="passwordNewIsValid ? 'none' : 'block'" i18n="@@UserPasswordSetPasswordNewInvalidWarning">
            Your new password must be {{passwordMinLength}}-{{passwordMaxLength}} characters long</div>

          <div class="invalid-feedback text-wrap mt-2 ms-2 fw-bold"
            [style.display]="passwordNewMatching ? 'none' : 'block'"
            i18n="@@UserPasswordSetPasswordNewMatchingInvalidWarning">Your new password inputs do not match each other</div>

        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-success" data-bs-dismiss="modal" (click)="submitAsync($event)"
          [disabled]="!formIsValid">{{ submitButtonLabel }}</button>
        <button type="button" class="btn btn-warning" data-bs-dismiss="modal" (click)="cancel($event)">{{
          cancelButtonLabel }}</button>
      </div>

    </div>
  </div>
</div>